@if (label) {
  <span class="copy-text__label">{{ label }}</span>
}
<span class="copy-text__row">
  <span class="copy-text__value" [title]="value">{{ value }}</span>
  <button mat-icon-button type="button"
          class="copy-text__btn"
          aria-label="Скопировать"
          matTooltip="Скопировать"
          (click)="onCopy()">
    <mat-icon>content_copy</mat-icon>
  </button>
</span>
